var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.491,
    height: 18.492,
    viewBox: "0 0 18.491 18.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4a87f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.062,959.361c-.542-.006-1.051.293-1.062.746V977.1c.056.6.581.72,1.062.752H24.436c.459.011,1.028-.292,1.055-.752V960.107c-.149-.593-.562-.721-1.055-.746Zm.228,1.29H24.2v15.911H8.29Zm12.531,3.87-6.4,6.37-2.748-2.735-.907.907c1.217,1.21,2.441,2.414,3.655,3.628q3.651-3.639,7.311-7.27Z",
    transform: "translate(-7 -959.361)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.91d712eb1b6d478682be427f4263e8ff.svg";
export { ForwardRef as ReactComponent };